module.exports = __webpack_public_path__ + "static/media/pen-to-square-regular.7427aa73.svg";